import { isNil } from 'lodash';
import React, { useContext } from 'react';
import { FieldLabel } from '@shared/components/FieldLabel';
import { MBView } from '@shared/components/MBView';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBIconV2, MBIconV2Name } from '@shared/components/image';
import { ColorThemeContext } from '@shared/styles';
import { API } from '@shared/types/api';
import { isInputComponent } from '../../utils';
import { WorkflowComponentStyles } from './WorkflowComponentStyles';

interface Props {
  children: React.ReactNode;
  extraChildren?: React.ReactNode;
  paddingHorizontal: number;
  iconPad: number;
  component: API.AnyComponent;
  showLabel: boolean;
  showIcon?: boolean;
  error?: string;
}

export function WorkflowComponentWrapper({
  children,
  extraChildren,
  paddingHorizontal,
  iconPad,
  component,
  showLabel,
  showIcon = true,
  error,
}: Props) {
  const colors = useContext(ColorThemeContext);
  const hasError = !isNil(error);

  if (!isInputComponent(component)) {
    return null;
  }

  return (
    <MBView
      style={[
        WorkflowComponentStyles.wrapper,
        hasError && {
          borderColor: colors.error.border,
          backgroundColor: colors.error.background,
        },
      ]}
    >
      <MBView paddingHorizontal={paddingHorizontal} fullWidth>
        <View row centerVertically style={{ flexGrow: 1 }}>
          {!isNil(component.icon) && showIcon && (
            <MBView paddingRight={iconPad} style={{ flexShrink: 0, flexGrow: 0 }}>
              <MBIconV2
                color={!isNil(error) ? colors.error.foreground : colors.accent}
                name={component.icon as MBIconV2Name}
                size={40}
              />
            </MBView>
          )}
          <View flex style={{ flexDirection: 'column', flexShrink: 0, flexGrow: 1 }}>
            {showLabel && (
              <View>
                <FieldLabel label={component.label} />
              </View>
            )}
            {children}
          </View>
        </View>
        {extraChildren && (
          <View paddingLeft={showIcon ? 40 / 8 + iconPad : 0}>{extraChildren}</View>
        )}
        {hasError && (
          <MBView style={WorkflowComponentStyles.error}>
            <Text size="body2" danger>
              {error}
            </Text>
          </MBView>
        )}
      </MBView>
    </MBView>
  );
}
